import { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Button } from "@components/buttons/button";
import Footer from "@components/layout/footer";
import { IProfitTypeDTO } from "@hooks/dtos/profit/IProfitTypeDTO";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { api } from "@service/api";

import { LandingHero } from "./components/LandingHero";
import { PartnerNetworkSection } from "./components/PartnerNetworkSection";
import { PublicProfilesSection } from "./components/PublicProfilesSection";
import { CampaignModelsSection } from "./components/CampaignModelsSection";

export function Land() {
  const { customer } = ZuAuthStore();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();
  const navigate = useNavigate();

  const [profitTypes, setProfitTypes] = useState<IProfitTypeDTO[]>([]);
  const [isLoadingProfitTypes, setIsLoadingProfitTypes] = useState(true);

  useEffect(() => {
    async function loadProfitTypes() {
      setIsLoadingProfitTypes(true);

      try {
        const response = await api.get("/raffle/profitTypes?status=a");
        setProfitTypes(response.data || []);
      } catch (error: any) {
        pushToastify({
          message:
            error?.response?.data?.message ||
            "Falha ao carregar os modelos de campanha.",
          type: "error",
          theme: "dark",
        });
      } finally {
        setIsLoadingProfitTypes(false);
      }
    }

    loadProfitTypes();
  }, [pushToastify]);

  const goToEntry = () => navigate(customer ? "/dashboard" : "/login");

  return (
    <>
      <main className="landing-page bg-white">
        <LandingHero
          isAuthenticated={!!customer}
          onGoHome={() => navigate("/")}
          onGoLogin={() => navigate("/login")}
          onGoEntry={goToEntry}
        />

        <CampaignModelsSection
          profitTypes={profitTypes || ({} as IProfitTypeDTO)}
          isLoading={isLoadingProfitTypes}
        />

        <PartnerNetworkSection onGoEntry={goToEntry} />

        <PublicProfilesSection />

        <section id="como-funciona" className="landing-cta-section py-5">
          <div className="container">
          <div className="bg-dark text-white rounded-4 p-4 p-lg-5">
            <div className="row align-items-center g-4">
              <div className="col-lg-8">
                <small className="text-white-50">
                  Pronto para criar sua próxima campanha?
                </small>
                <h2 className="fw-bold text-white mb-2">
                  Transforme ideias em grandes resultados.
                </h2>
                <p className="text-white-50 mb-0">
                  Publique, acompanhe vendas, negocie com parceiros e mantenha o
                  financeiro organizado do começo ao fim.
                </p>
              </div>
              <div className="col-lg-4 text-lg-end">
                <Button
                  className="btn btn-primary rounded-4 text-white px-5 py-3"
                  onClick={goToEntry}
                >
                  {customer ? `Acessar Dashboard` : `Criar minha conta`} agora
                  <FaArrowRight className="ms-2" />
                </Button>
              </div>
            </div>
          </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

